module.exports = __webpack_public_path__ + "img/lock-active.e295e2fa.svg";